import { TotalModeEnum } from '@e-socna/data-layer';
import type { Id } from '@e-socna/data-layer';

// Minimal per-group shape the aggregation level utils need - built by the
// caller from whichever fragment is available (live ServicesInfo groups),
// see docs/spec/00-project-spec.md §"Total per group" ->
// "Accounting aggregation level".
export interface AggregationLevelGroupInput {
  readonly id: Id;
  readonly label: string;
  readonly totalMode: TotalModeEnum;
  readonly manualTotalVatId?: Id | null;
  readonly serviceUsageVatIds: readonly Id[];
}

export function resolveGroupVatIds(
  group: Readonly<AggregationLevelGroupInput>,
): readonly Id[] {
  if (group.totalMode === TotalModeEnum.Manual) {
    return group.manualTotalVatId ? [group.manualTotalVatId] : [];
  }

  return group.serviceUsageVatIds;
}
